import { useCallback, useState } from "react";
import { useAuth } from "../contexts/auth-context";

export function useActivityBadge() {
  const { unread, clearUnread } = useAuth();

  // WS-driven increments on top of server-provided counts
  const [galleryExtra, setGalleryExtra] = useState(0);
  const [activityExtra, setActivityExtra] = useState(0);

  const galleryUnread = unread.gallery + galleryExtra;
  const activityUnread = unread.activity + activityExtra;

  const incrementGallery = useCallback(() => setGalleryExtra((c) => c + 1), []);
  const incrementActivity = useCallback(() => setActivityExtra((c) => c + 1), []);

  // Zero BOTH halves: the local WS-driven delta AND the server-reported
  // baseline from session start — clearing only the delta left the badge
  // stuck forever if there was any unread count at login (2026-08-14 bug).
  const resetGallery = useCallback(() => {
    setGalleryExtra(0);
    clearUnread("gallery");
  }, [clearUnread]);
  const resetActivity = useCallback(() => {
    setActivityExtra(0);
    clearUnread("activity");
  }, [clearUnread]);

  return {
    galleryUnread,
    activityUnread,
    incrementGallery,
    incrementActivity,
    resetGallery,
    resetActivity,
  };
}
